import {SchedulingProgress} from '../../../../shared/campaign/SchedulingProgress';

export default function SchedulingProgressIntegration({
  items = [],
  summary = null,
  isRunning = false,
  errorMessage = null,
}) {
  return (
    <SchedulingProgress
      items={items}
      summary={summary}
      isRunning={isRunning}
      errorMessage={errorMessage}
    />
  );
}
